import { IconBook, IconUsers,IconReport,IconMessage, IconReportAnalytics, IconSettings, IconListDetails, IconUserUp, IconSpeakerphone, IconShare, IconSend, IconMail, IconUsersGroup, IconLayoutDashboard, IconCreditCard, IconX} from '@tabler/icons-react'

export function NavItem({navtitle, active,icon2,onClick,navdata,style}){
    return(

        <button style={style} onClick={onClick}  data-testid={navdata} className={`horizontal nav-item-name nav-item ${active&&'active'}`} >
            <CorrectIcon icon={icon2}/>
            <div className="phone-sidebar-text" style={{marginLeft:"0.3rem"}}> {navtitle}</div>
        </button>
    )

}

function CorrectIcon({icon, color="var(--grey-600)"}) {
    switch(icon){
        case "dashboard":return <IconLayoutDashboard />
        case "courses":return <IconBook />
        case "users":return <IconUsers />
        case "reports":return <IconReport />
        case "message":return <IconMessage/>
        case "analytic":return <IconReportAnalytics/>
        case "setting":return <IconSettings/>
        case 'project': return <IconListDetails />
        case 'leads': return <IconUserUp/>
        case 'campagne': return <IconSpeakerphone/>
        case 'message': return <IconMessage/>
        case 'send': return <IconSend/>
        case 'share': return <IconShare/>
        case 'mail': return <IconMail/>
        case 'book': return <IconBook/>
        case 'department': return <IconUsersGroup/>
        case 'card': return <IconCreditCard/>
        default:return <></>
    }
}